import React from "react";
import UserList from "./UserList";

function Vendor() {
  return <UserList type="Vendor" title="Vendor" />;
}

export default Vendor;
